import { admin, baseURL, client } from './main'
import {
  CitiesList,
  Categories,
  FoodItemInfo,
  Stories,
  Banners,
  PickupPoints,
  ProfilePatchFields,
  NewAddress,
  Sales,
  PaymentMethodList,
  ProfileData,
  OrdersHistory,
  OrderFromHistory,
  SupportChatData,
  OrderEstimate,
  OrderFromHistoryData,
  OrderAssebleResponce,
  PromoCodeResponse,
  CitiesEnum,
  CitiesEnumResponse,
  DadataResponse,
  SearchResultResponce,
  OrderEstimateResponse,
  DadataAddressResponse,
  DataMapTokenResponse,
} from '../types/types.api'
import { OrderAsseble, PromoCode } from '../types/types.user'

// --------------- GET

export const getCitiesList = async () => {
  try {
    return (await client.get('cities')).data
  } catch (e) {
    console.log(e)
  }
}

export const getMaxFilledPickup = async (city_id: number) => {
  try {
    return (
      await client.get('max_filled_pickup_point', {
        params: {
          city_id,
        },
      })
    ).data
  } catch (e) {
    console.log(e)
  }
}

export const getCategories = async () => {
  try {
    return (await client.get('categories')).data
  } catch (e) {
    console.log(e)
  }
}

export const getCategoriesStopLit = async (id: number) => {
  try {
    return (await client.get(`categories/stoplists?location_id=${id}`)).data
  } catch (e) {
    console.log(e)
  }
}

export const getFoodItemInfo = async (items_id: string) => {
  try {
    return (await client.get(`items?items_id=${items_id}`)).data
  } catch (e) {
    console.log(e)
  }
}

export const getFoodItemInfoStopList = async (items_id: string, location_id: string) => {
  try {
    return (await client.get(`items/stoplists?items_id=${items_id}&location_id=${location_id}`))
      .data
  } catch (e) {
    console.log(e)
  }
}

export const getStories = async () => {
  try {
    return (await client.get('stories')).data
  } catch (e) {
    console.log(e)
  }
}

export const getBanners = async () => {
  try {
    return (await client.get('banners')).data
  } catch (e) {
    console.log(e)
  }
}

export const getPickupPoints = async (city_id: number) => {
  // client.query({ city_id })
  try {
    return (await client.get(`/pickup_points_test?city_id=${city_id}`)).data
  } catch (e) {
    console.log(e)
  }
}

export const getOrders = async () => {
  try {
    return (await client.get('orders')).data
  } catch (e) {
    console.log(e)
  }
}

export const getOrder = async (id: number) => {
  try {
    return (await client.get(`orders/${id}`)).data
  } catch (e) {
    console.log(e)
  }
}

export const getOrdersCount = async () => {
  try {
    return (await client.get('orders/count')).data
  } catch (e) {
    console.log(e)
  }
}

export const getUserAddresses = async (id?: number) => {
  try {
    if (id) return (await client.get(`addresses?city_id=${id}`)).data
    return (
      await client.get(`addresses`, {
        cache: false,
      })
    ).data
  } catch (e) {
    console.log(e)
  }
}

export const getAddressesCount = async () => {
  try {
    return (await client.get('addresses/count')).data
  } catch (e) {
    console.log(e)
  }
}

export const getBonusesCount = async () => {
  try {
    return (await client.get('bonuses/count')).data
  } catch (e) {
    console.log(e)
  }
}

export const getSales = async () => {
  try {
    return (await client.get('available_promo_codes')).data
  } catch (e) {
    console.log(e)
  }
}

export const getSavedCards = async () => {
  try {
    return (await client.get('saved_cards')).data
  } catch (e) {
    console.log(e)
  }
}

export const getProfileData = async (token?: string) => {
  try {
    if (token) {
      return (
        await client.get('profile', {
          headers: {
            Authorization: `Token ${token}`,
          },
          cache: false,
        })
      ).data
    }

    return (
      await client.get('profile', {
        cache: false,
      })
    ).data
  } catch (e) {
    console.log(e)
  }
}

export const getCitiesIds = async () => {
  try {
    return (await client.get('enums/cities')).data
  } catch (e) {
    console.log(e)
  }
}

export const getDadata = async (city: string, query: string) => {
  // client.query({ city, query })

  try {
    return (await client.get('dadata', { params: { city, query } })).data
  } catch (e) {
    console.log(e)
  }
}

export const getDadataStreet = async (city: string, street: string, house: string) => {
  try {
    return (await client.get('dadata', { params: { city, street, house } })).data
  } catch (e) {
    console.log(e)
  }
}

export const getSearchResults = async (query: {
  search: string
  count: number
  offset: number
}) => {
  try {
    return (await client.get('search', { params: { ...query } })).data
  } catch (e) {
    console.log(e)
  }
}

export const getMapToken = async () => {
  try {
    return (await client.get('/mapkit_token')).data
  } catch (e) {
    console.log(e)
  }
}

// --------------- POST

export const postStoriesWatchCount = async (id: number) => {
  try {
    return (await client.post(`stories/${id}/views`, {})).data
  } catch (e) {
    console.log(e)
  }
}

export const postPhoneAuth = async (data: {
  phone: string
  type?: 'flashcall' | 'sms' | 'tg'
  code?: string
}) => {
  try {
    return (await client.post('auth', data)).data
  } catch (e) {
    console.log(e)
  }
}

export const postPromoValidation = async (promo_code: string) => {
  try {
    return (await client.post('check_promo', { promo_code })).data
  } catch (e) {
    console.log(e)
  }
}

export const postNewAddress = async (data: NewAddress) => {
  try {
    return (await client.post('addresses', data)).data
  } catch (e) {
    console.log(e)
  }
}

export const orderEstimate = async (order: OrderAsseble) => {
  try {
    return (await client.post('orders/estimate', { ...order })).data
  } catch (e) {
    console.log(e)
  }
}

export const orderAsseble = async (order_id: number) => {
  try {
    return (await client.post('orders/assemble', { order_id })).data
  } catch (e) {
    console.log(e)
  }
}

export const orderPayment = async (order_id: number): Promise<any> => {
  try {
    return (await client.post(`orders/pay/${order_id}`, {})).data
  } catch (e) {
    console.log(e)
  }
}

export const postMedia = async (file: File): Promise<{ data: string[]; status: 'ERR' | 'OK' }> => {
  let token = localStorage.getItem('token')

  if (!token) {
    token = sessionStorage.getItem('guestToken') || localStorage.getItem('guestToken')
  }

  const fd = new FormData()
  fd.append('file', file)

  return (
    await admin.post('support_chat/upload', fd, {
      headers: {
        'Content-Type': 'multipart/formdata',
        Authorization: `Token ${token}`,
      },
    })
  ).data

  // const response = await fetch(baseURL + 'support_chat/upload', {
  //   method: 'POST',
  //   headers: {
  //     Authorization: `Token ${token}`,
  //   },
  //   body: fd,
  // })
  //
  // return response.json()
}

// --------------- PATCH

export const patchAddress = async (address_id: string, data: NewAddress) => {
  try {
    return (await client.patch('addresses', { ...data, address_id })).data
  } catch (e) {
    console.log(e)
  }
}

export const patchProfile = async (data: ProfilePatchFields) => {
  try {
    return (await client.patch('profile', data)).data
  } catch (e) {
    console.log(e)
  }
}

// --------------- DELETE

export const deleteProfile = async () => {
  try {
    return (await client.delete('profile')).data
  } catch (e) {
    console.log(e)
  }
}

export const deleteCard = async (id: number) => {
  try {
    return (await client.delete(`saved_cards/${id}`)).data
  } catch (e) {
    console.log(e)
  }
}

export const deleteUserAddress = async (addressId: string | number) => {
  try {
    return await client.delete(`addresses/${addressId}`)
  } catch (e) {
    console.log(e)
  }
}

// --------------- CHAT REQUESTS

export const postChatMessage = async (text: string, media?: string): Promise<SupportChatData> => {
  let token = localStorage.getItem('token')

  if (!token) {
    token = sessionStorage.getItem('guestToken') || localStorage.getItem('guestToken')
  }

  const body: Record<string, string> = { text }

  if (media) {
    body.media = media
  }

  try {
    return (
      await admin.post(
        `support_chat`,
        { ...body },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${token}`,
          },
        }
      )
    ).data
  } catch (e) {
    console.log(e)
  }
}

export const getSupportChat = async (): Promise<SupportChatData> => {
  let token = localStorage.getItem('token')

  if (!token) {
    token = sessionStorage.getItem('guestToken') || localStorage.getItem('guestToken')
  }

  try {
    return (
      await admin.get(`support_chat`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
    ).data
  } catch (e) {
    console.log(e)
  }

  // const response = await fetch(baseURL + 'support_chat', {
  //   method: 'GET',
  //   headers: {
  //     Authorization: `Token ${token}`,
  //   },
  // })
  //
  // return response.json()
  // return client.get('support_chat')
}
